module.exports = __webpack_public_path__ + "static/media/ps-site800w.2ff68027.png";